import { RouteRecordRaw } from 'vue-router'

const routes: Array<RouteRecordRaw> = [
  {
    path: 'login',
    name: 'login',
    component: () => import('./Login.vue'),
  },
  {
    path: 'logout',
    name: 'logout',
    component: () => import('./Logout.vue'),
  },
  {
    path: 'otp-login',
    name: 'otp-login',
    component: () => import('./OtpLogin.vue'),
  },
  {
    path: 'register',
    name: 'register',
    component: () => import('./Register.vue'),
  },
]

export default routes
